export const BRAND_ILLUSTRATIONS_2026_FLAG = 'brand-illustrations-2026' as const;
